import axios from "axios";
import { awsUrl, newApiBaseUrl } from "../../axiosInstance";
import * as actionType from "../store/action";
import showAlert from "../server/ShowAlert";
import { setPreload } from "../server/CartsOpen";

export const customerList = () => {
  return (dispatch) => {
    axios
      .get(`${newApiBaseUrl}/users/me/favorites/lists`, {
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
          "X-Tenant": "hamazon",
          "Content-Type": "application/json",
        },
      })
      .then((x) => {
        if (x.data.lists) {
          dispatch({ type: actionType.SET_SHOP_LIST, payload: x.data.lists });
        } else {
          showAlert({
            msgTitle: "הייתה בעיה  בשליפת הרשימה",
            msgType: "error",
          });
        }
      });
  };
};

export const customerListClear = () => {
  return (dispatch) => {
    dispatch({ type: actionType.SET_SHOP_LIST, payload: [] });
  };
};

export const addNewList = (name, description) => {
  const val = {
    name,
    description: description ? description : "",
  };
  return (dispatch) => {
    dispatch(setPreload(true));
    axios
      .post(`${newApiBaseUrl}/users/me/favorites/lists`, val, {
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
          "X-Tenant": "hamazon",
          "Content-Type": "application/json",
        },
      })
      .then((x) => {
        if (x.data) {
          dispatch({ type: actionType.ADD_NEW_SHOP_LIST, payload: x.data });
          showAlert({ msgTitle: "הרשימה נוספה בהצלחה", msgType: "success" });
        } else {
          showAlert({ msgTitle: "הייתה בעיה בהוספת הרשימה", msgType: "error" });
        }
      })
      .finally(() => dispatch(setPreload(false)));
  };
};

export const customerListId = (listId, stationId) => {
  return axios.get(
    `${newApiBaseUrl}/users/me/favorites/lists/${listId}?branch=${stationId}`,
    {
      headers: {
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
        "Content-Type": "application/json",
      },
    },
  );
};
export const addToCard = (branch, products) => {
  if (!products || products.length === 0) {
    console.log("products.length === 0");

    return Promise.reject("אין מוצרים לשליחה");
  }
  return axios.put(
    `${newApiBaseUrl}/users/me/cart/items/batch`,
    {
      branch,
      items: products.map((p) => ({
        productId: p.productId,
        quantity: Number(p.quantity),
        unitPrice: Number(p.unitPrice || p.product?.pricing?.price || 1),
        weightJump: p.product?.weightJump,
      })),
    },
    {
      headers: {
        Authorization: `bearer ${localStorage.jwtToken}`,
        "x-tenant": "hamazon",
        "Content-Type": "application/json",
      },
    },
  );
};

export const addProductToList = (listId, productId, quantity) => {
  return axios.put(
    `${newApiBaseUrl}/users/me/favorites/lists/${listId}/items/${productId}`,
    { quantity },
    {
      headers: {
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
        "Content-Type": "application/json",
      },
    },
  );
};

export const deleteList = (listId) => {
  return (dispatch) => {
    axios
      .delete(`${newApiBaseUrl}/users/me/favorites/lists/${listId}`, {
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
          "X-Tenant": "hamazon",
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200) {
          dispatch({ type: actionType.DELETE_SHOP_LIST, payload: listId });
          showAlert({ msgTitle: "הרשימה נמחקה בהצלחה", msgType: "success" });
        } else {
          showAlert({ msgTitle: "הייתה בעיה במחיקת הרשימה", msgType: "error" });
        }
      });
  };
};

export const deleteAllList = (lists) => {
  const deletePromises = lists.map((list) => {
    return axios.delete(`${awsUrl}/v1/lists/${list.Id}`, {
      headers: {
        Authorization: `bearer ${localStorage.getItem("jwtToken")}`,
      },
    });
  });
  return (dispatch) => {
    Promise.all(deletePromises)
      .then(() => {
        dispatch({ type: actionType.DELETE_ALL_SHOP_LIST });
      })
      .catch((error) => {
        console.log("שגיאה במחיקת אחת או יותר מהרשימות:", error);
      });
  };
};
export const updateListName = (listId, editedName) => {
  return async (dispatch) => {
    try {
      const response = await axios.put(
        `${newApiBaseUrl}/users/me/favorites/lists/${listId}`,
        { name: editedName },
        {
          headers: {
            Authorization: `bearer ${localStorage.jwtToken}`,
            "X-Tenant": "hamazon",
            "Content-Type": "application/json",
          },
        },
      );

      dispatch({
        type: actionType.UPDATE_SHOP_LIST_NAME,
        payload: response.data,
      });
      showAlert({ msgTitle: "שם הרשימה עודכן בהצלחה", msgType: "success" });
    } catch (error) {
      console.error("Error updating list name:", error);
      showAlert({ msgTitle: "שגיאה בעדכון הרשימה", msgType: "error" });
    }
  };
};
